module.exports = __webpack_public_path__ + "static/img/img2_en.73296bb3.png";